<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleStatusDetailSection from './PostSaleStatusDetailSection.vue';
import {
  deedAddress,
  payloadOf,
  textOf,
} from './postSaleStatusDetailPresenter';

const props = defineProps({ event: { type: Object, required: true } });
const { t } = useI18n();
const sections = computed(() => {
  const payload = payloadOf(props.event);
  const deed = payload.escritura || payload;
  const empty = t('POST_SALE.COMMON.EMPTY_VALUE');

  return [
    {
      title: t('POST_SALE.STATUS_DETAILS.APPOINTMENT'),
      items: [
        {
          label: t('POST_SALE.STATUS_DETAILS.DAY'),
          value: textOf(deed.data_escritura, empty, t),
        },
        {
          label: t('POST_SALE.STATUS_DETAILS.TIME'),
          value: textOf(deed.hora_escritura, empty, t),
        },
      ],
    },
    {
      title: t('POST_SALE.STATUS_DETAILS.LOCATION'),
      items: [
        {
          label: t('POST_SALE.STATUS_DETAILS.NOTARY_OFFICE'),
          value: textOf(deed.local_escritura, empty, t),
        },
        {
          label: t('POST_SALE.STATUS_DETAILS.ADDRESS'),
          value: deedAddress(deed) || empty,
        },
      ],
    },
  ];
});
</script>

<template>
  <div class="grid gap-4">
    <PostSaleStatusDetailSection
      v-for="section in sections"
      :key="section.title"
      v-bind="section"
    />
  </div>
</template>
